// @ts-strict-ignore
import { useState } from "react";

import { VerifyMFAForm } from "@shared/MultifactorAuthentication/components/legacy/VerifyMFAForm/VerifyMFAForm";
import { TwoFactorAuthenticationMethods } from "@shared/types/graphqlGenerated";
import { SignInBlock } from "@unauthenticated/shared/components/SignInBlock/SignInBlock";
import { SsoErrorPage } from "@unauthenticated/shared/components/SSOErrorBox/types/ssoErrorPage";

import { OAuthStep } from "../oauthStep";

interface Props {
  ssoErrors?: string;
  authErrors?: string;
  onUpdateCurrentStep: (step: OAuthStep) => void;
  setSsoErrorMessage: (error: string) => void;
  onSignInComplete: () => void;
}

const additionalAttributes = {
  redirectPath: window.location.href,
  isOauth: true,
  formVersion: "OAuthSigninPage",
  externalApplicationId: new URL(location.href).searchParams.get("client_id"),
};

const OAuthSignInStep = ({
  ssoErrors,
  authErrors,
  onUpdateCurrentStep,
  setSsoErrorMessage,
  onSignInComplete,
}: Props) => {
  const [errorMessage, setErrorMessage] = useState(authErrors);
  const [isShowTwoFactorFlow, setIsShowTwoFactorFlow] = useState(false);
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [twoFactorAuthToken, setTwoFactorAuthToken] = useState("");
  const [isLockedOut, setIsLockedOut] = useState(false);
  const [userOtpMethod, setUserOtpMethod] = useState<TwoFactorAuthenticationMethods>(
    TwoFactorAuthenticationMethods.Email
  );

  const handleShowTwoFactorFlow = ({ otpMethod, emailMasked, phoneLast4, authToken }) => {
    setIsShowTwoFactorFlow(true);
    setTwoFactorAuthToken(authToken);
    setUserOtpMethod(otpMethod);
    setEmail(emailMasked);
    setPhone(phoneLast4);
  };

  const handleBackToSignIn = () => {
    setIsShowTwoFactorFlow(false);
  };

  const handleUserLockedOut = () => {
    setIsLockedOut(true);
    handleBackToSignIn();
  };

  const handleOnCompleted = completedData => {
    const validUser = completedData?.auth?.userSignIn?.user;

    if (validUser) {
      onSignInComplete();
    } else {
      const dataError = completedData?.auth?.userSignIn?.errors.message;
      setErrorMessage(dataError);
    }
  };

  const handleSignUpRedirect = () => {
    setSsoErrorMessage(null);
    onUpdateCurrentStep(OAuthStep.SIGN_UP);
  };

  if (isShowTwoFactorFlow) {
    return (
      <VerifyMFAForm
        emailMasked={email}
        phoneLast4={phone}
        otpMethod={userOtpMethod}
        twoFactorAuthToken={twoFactorAuthToken}
        onBackToSignIn={handleBackToSignIn}
        onUserLockedOut={handleUserLockedOut}
        onCompleted={onSignInComplete}
      />
    );
  }

  return (
    <SignInBlock
      ssoErrorPage={SsoErrorPage.OAUTH}
      ssoErrors={ssoErrors}
      onCompleted={handleOnCompleted}
      additionalAttributes={additionalAttributes}
      authErrors={errorMessage}
      onSignUpRedirect={handleSignUpRedirect}
      isOAuth
      onShowTwoFactorFlow={handleShowTwoFactorFlow}
      isLockedOut={isLockedOut}
    />
  );
};

export { OAuthSignInStep };
